<div class="header">
	<app-header *ngIf="session" [session]="session"></app-header>
</div>

<router-outlet *ngIf="session"></router-outlet>

<!-- <div class="footer">
	<app-footer></app-footer>
</div> -->